import React from "react";

function CompAddTypeSelector(props) {
  return (
    <div>
      {props.typeTemplates.map(typeTemplate => (
        <button
          key={typeTemplate.get("type")}
          onClick={e => {
            e.stopPropagation();
            props.selected(props.attr, typeTemplate);
          }}
        >
          {typeTemplate.get("name")}
        </button>
      ))}
    </div>
  );
}
export default CompAddTypeSelector;



// WEBPACK FOOTER //
// ./src/components/CompAddTypeSelector.js